import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_app/system/ai-roadmap/")({
  // UI-only page for now
  loader: () => Promise.resolve({}),
})


